import styled from 'styled-components';

import { media } from '@ovpn-ui/styles';
import { NavPusher } from '@ovpn-ui/navigation';

export const HeaderPusher = styled(NavPusher)`
    position: absolute;
    right: 0;
    left: 0;

    height: auto;
    margin-top: var(--sidebar-top-offset);

    ${media.SM`
        margin-top: calc(var(--sidebar-top-offset) + 55px);
    `}
`;
